import {setHeaderHeight} from "./modules/setHeaderHeight.js";
import {scrolledDown} from "./modules/scrolledDown.js";

import.meta.glob([
	'../images/**',
	'../fonts/**',
]);

const loadIfPresent = (selector, callback) => {
	if (document.querySelector(selector)) {
		callback();
	}
};

document.addEventListener('DOMContentLoaded', function () {
	// setHeaderHeight();
	scrolledDown();

	// The Lottie runtime is heavy — only fetch it where a <lottie-player> is used
	// (Lottie-Icon, Icon-Text Karten). Elements already in the DOM upgrade once it is defined.
	loadIfPresent('lottie-player', () => import("@lottiefiles/lottie-player"));

	loadIfPresent('.rank-math-breadcrumb', async () => {
		const {initBreadcrumbs} = await import("./modules/breadcrumbs.js");
		initBreadcrumbs();
	});

	loadIfPresent('.wp-block-acf-accordion', async () => {
		const {blockAccordion} = await import("./blocks/accordions.js");
		blockAccordion();
	});

	loadIfPresent('.wp-block-acf-imageslider', async () => {
		const {imageSlider} = await import("./blocks/imageslider.js");
		imageSlider();
	});

	loadIfPresent('.wp-block-acf-image-teaser', async () => {
		const {imageTeaser} = await import("./blocks/image-teaser.js");
		imageTeaser();
	});

	loadIfPresent('.wp-block-acf-testimonials-slider', async () => {
		const {testimonialsSlider} = await import("./blocks/testimonials-slider.js");
		testimonialsSlider();
	});

	loadIfPresent('.wp-block-acf-sequence-teaser', async () => {
		const {sequenceTeaser} = await import("./blocks/sequence-teaser.js");
		sequenceTeaser();
	});

	loadIfPresent('.wp-block-acf-gallery', async () => {
		const {gallery} = await import("./blocks/gallery.js");
		gallery();
	});

	loadIfPresent('.wp-block-acf-hero', async () => {
		const {heroVideo} = await import("./blocks/hero.js");
		heroVideo();
	});

	loadIfPresent('.project-slider', async () => {
		const {projectSlider} = await import("./blocks/project-slider.js");
		projectSlider();
	});

	loadIfPresent('.projects-archive', async () => {
		const {projectsArchive} = await import("./modules/projectsArchive.js");
		projectsArchive();
	});

	loadIfPresent('.footer-nav__toggle', async () => {
		const {footerAccordion} = await import("./modules/footerAccordion.js");
		footerAccordion();
	});

	loadIfPresent('.icon', async () => {
		const {subMenuToggle, subMenuHover} = await import("./modules/subMenuToggle.js");
		subMenuToggle();
		subMenuHover();
	});
}, false);